module.exports = __webpack_public_path__ + "img/Icon-Timer-grey.519dd729.svg";